<template>
  <div class="slider-container">
    <Carousel
        ref="carousel"
        :items-to-show="itemsToShow"
        :wrap-around="false"
        :mouse-drag="true"
        :snap-align="'start'"
        :breakpoints="breakpoints"
        class="slider products"
        @slide-start="handleSwipe"
    >
      <Slide v-for="item in list" :key="item.id" class="item">
        <ProductCard
            :isPack="isPack"
            :lazy="true"
            :isAuth="isAuth"
            :activePack="activePack"
            :item="item"
            :tag="tag"
            :sliderIsClickble="sliderIsClickble"
            :currency="currency"
            @openSignInModal="openSignInModal"
            @openReadyModal="openReadyModal"
            @goToProduct="goToProduct"
        />
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide } from 'vue3-carousel';
import ProductCard from '../components/ProductCard.vue';

export default defineComponent({
  emits: ['goToProduct', 'openReadyModal', 'openSignInModal'],
  name: 'SlickItem',
  props: ['list', 'tag', 'currency', 'isPack', 'activePack', 'isAuth'],

  components: {
    Carousel,
    Slide,
    ProductCard
  },

  data() {
    return {
      imgDomain: '',
      sliderIsClickble: true,
      itemsToShow: 4,
      breakpoints: {
        1200: {
          itemsToShow: 3
        },
        900: {
          itemsToShow: 2
        },
        768: {
          itemsToShow: 2
        },
        600: {
          itemsToShow: 1
        },
        449: {
          itemsToShow: 1
        }
      }
    };
  },

  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },

  methods: {
    handleSwipe() {
      this.sliderIsClickble = false;
      setTimeout(() => {
        this.sliderIsClickble = true;
      }, 300);
    },
    goToProduct(item) {
      this.$emit('goToProduct', item);
    },
    openReadyModal(item, product) {
      this.$emit('openReadyModal', item, product);
    },
    openSignInModal() {
      this.$emit('openSignInModal');
    }
  }
});
</script>

<style scoped>
/* при необходимости подгони классы под .slider и .item */
</style>
